import $ from 'jquery';

$(function () {
	var state = false;
	var scrollpos;

	$('.gnavi-btn').on('click', function() {
		if (state == false) {
			scrollpos = $(window).scrollTop();
			$('body').addClass('fixed').css({
				'top': -scrollpos
			});
			$('.gnavi,.gnavi-bg').toggleClass('is-opened');
			$(this).toggleClass('active');
			state = true;
		} else {
			$('body').removeClass('fixed').css({
				'top': 0
			});
			window.scrollTo(0, scrollpos);
			$('.gnavi,.gnavi-bg').toggleClass('is-opened');
			$(this).toggleClass('active');
			state = false;
		}
	});
});

var w = $(window).width();
var x = 768;
if (w <= x) {
	$('.gnavi .toggle-btn').on('click', function() {
		$(this).toggleClass('active');
		$(this).next().toggleClass('is-opened');
		return false;
	});
}